import React from "react";
import { ChevronRight } from "lucide-react";

// One setting on the Settings page: icon tile in the section's tone, title
// (with an optional badge), short description and a chevron. A real <button>,
// so it is reachable with Tab and opens with Enter/Space.
const SettingsItemContainer = ({
  setting,
  index,
  tone = "shade1",
  handleItemClick = () => {},
}) => {
  const Icon = setting.icon;
  return (
    <button
      type="button"
      key={index}
      onClick={() => handleItemClick(index, setting)}
      className="group w-full h-full text-left flex items-start gap-4 p-5 rounded-2xl border border-[var(--light-border-color)] bg-white transition-all duration-200 hover:border-[var(--primary)] hover:shadow-[0_8px_24px_-12px_rgba(39,125,254,0.45)] hover:-translate-y-0.5 focus:outline-none focus-visible:border-[var(--primary)] focus-visible:ring-2 focus-visible:ring-[var(--row-selection-color)]"
    >
      <span
        className="shrink-0 w-11 h-11 rounded-xl flex items-center justify-center"
        style={{
          background: `var(--reports-${tone}_bg)`,
          color: `var(--reports-${tone}_text)`,
        }}
      >
        {Icon && <Icon size={20} strokeWidth={1.8} />}
      </span>
      <span className="flex-1 min-w-0">
        <span className="flex items-center flex-wrap gap-x-2 gap-y-1">
          <span className="text-sm fw_600 text-[var(--heading-color)] group-hover:text-[var(--primary)]">
            {setting.title}
          </span>
          {setting.badge && (
            <span className="inline-flex items-center h-5 px-2 rounded-full border border-[var(--light-border-color)] bg-slate-50 text-[11px] fw_500 text-[var(--description-color)] whitespace-nowrap">
              {setting.badge}
            </span>
          )}
        </span>
        <span className="block mt-1 text-xs leading-5 text-[var(--description-color)] line-clamp-2">
          {setting.desc}
        </span>
      </span>
      <ChevronRight
        size={18}
        className="shrink-0 mt-0.5 text-[var(--description-color)] transition-all duration-200 group-hover:translate-x-0.5 group-hover:text-[var(--primary)]"
      />
    </button>
  );
};

export default SettingsItemContainer;
